import React, { useEffect, useState } from 'react'
import { Col, Input, Row, FormGroup, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Select from 'react-select'
import Switch from 'react-switch'
import { driedFruitsTypeOptions, packageTypeOptions } from './constants'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotAlpha, isNotNumericDecimal } from 'context/Utilities'

const DriedFruitsPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    DFType: item.DFType,
    DFPackageType: item.DFPackageType,
    DFSize: item.DFSize,
    Organic: item.Organic,
    NoAdditionalIngredients: item.NoAdditionalIngredients,
  })

  const tempType = {
    value: item.DFType,
    label: item.DFType,
  }
  const tempPackageType = {
    value: item.DFPackageType,
    label: item.DFPackageType,
  }

  const containsPackageType = packageTypeOptions.some(e => {
    return JSON.stringify(tempPackageType) === JSON.stringify(e)
  })
  const containsType = driedFruitsTypeOptions.some(e => {
    return JSON.stringify(tempType) === JSON.stringify(e)
  })

  if (containsPackageType) {
    packaging.DFPackageType = item.DFPackageType
  } else {
    packaging.DFPackageType = 'Other'
    packaging.otherPackageType = item.DFPackageType
    item.otherPackageType = item.DFPackageType
    item.DFPackageType = 'Other'
  }
  if (containsType) {
    packaging.DFType = item.DFType
  } else {
    packaging.DFType = 'Other'
    packaging.otherType = item.DFType
    item.otherType = item.DFType
    item.DFType = 'Other'
  }

  const methods = useFormContext()
  const {
    setSelectReviewer,
    setSwitchReviewer,
    onChangeReviewer,
    asterisk,
  } = useFormUtils()
  useEffect(() => {
    if (item !== null) {
      const {
        DFType,
        DFPackageType,
        DFSize,
        Organic,
        NoAdditionalIngredients,
      } = item
      setPackaging({
        DFType,
        DFPackageType,
        DFSize,
        Organic,
        NoAdditionalIngredients,
      })
    }
    // eslint-disable-next-line
    }, [item])
  return (
    <>
      <Row>
        <Col xs={4}>
          <p>
            <strong>Type {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={driedFruitsTypeOptions}
            defaultValue={{
              label: packaging.DFType,
              value: packaging.DFType,
            }}
            name="DFType"
            control={methods.control}
            rules={{ required: true }}
            placeholder={'Select Type'}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              setPackaging({
                ...packaging,
                DFType: value,
              })
              return selected
            }}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="DFType"
              message={'⚠ This selection is required.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
          <br />
          {item?.DFType === 'Other' && (
            <FormGroup>
              <p>
                <strong>Other Type (Please Specify) {asterisk}</strong>
              </p>
              <Controller
                as={Input}
                name="otherType"
                placeholder={'Other Type'}
                defaultValue={item.otherType}
                control={methods.control}
                rules={{ required: true }}
                onKeyDown={e => {
                  if (isNotAlpha(e.key)) {
                    e.preventDefault()
                  }
                }}
                onChange={([event]) => {
                  onChangeReviewer(item, event)
                  return event
                }}
                disabled={isDisabled}
              />
              <p className={'text-danger'}>
                <ErrorMessage
                  errors={methods.errors}
                  name="otherType"
                  message={'Other type is required.'}
                  as={<Alert color={'danger'} className={'mt-3'} />}
                />
              </p>
            </FormGroup>
          )}
          <FormGroup>
            <p>
              <strong>Size {asterisk}</strong>
            </p>
          </FormGroup>
          <Controller
            as={Input}
            name="DFSize"
            placeholder={'Size'}
            defaultValue={packaging.DFSize}
            control={methods.control}
            rules={{ required: true, maxLength: 5 }}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={isDisabled}
          />
          <p className={'text-danger'}>
            {methods.errors.DFSize &&
              methods.errors.DFSize.type === 'required' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ Size is required.
                </Alert>
              )}
            {methods.errors.DFSize &&
              methods.errors.DFSize.type === 'maxLength' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ Size exceeds 5 characters.
                </Alert>
              )}
          </p>
        </Col>
        <Col xs={4}>
          <p>
            <strong>Package Type {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={packageTypeOptions}
            defaultValue={{
              label: packaging.DFPackageType,
              value: packaging.DFPackageType,
            }}
            name="DFPackageType"
            control={methods.control}
            rules={{ required: true }}
            placeholder={'Select Package Type'}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              setPackaging({
                ...packaging,
                DFPackageType: value,
              })
              return selected
            }}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="DFPackageType"
              message={'⚠ Package type is required.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
          <br />
          {item?.DFPackageType === 'Other' && (
            <FormGroup>
              <p>
                <strong>Other Package Type (Please Specify) {asterisk}</strong>
              </p>
              <Controller
                as={Input}
                name="otherPackageType"
                placeholder={'Other Package Type'}
                defaultValue={item.otherPackageType}
                control={methods.control}
                rules={{ required: item.DFPackageType.includes('Other') }}
                onKeyDown={e => {
                  if (isNotAlpha(e.key)) {
                    e.preventDefault()
                  }
                }}
                onChange={([event]) => {
                  onChangeReviewer(item, event)
                  return event
                }}
                disabled={isDisabled}
              />
              <p className={'text-danger'}>
                <ErrorMessage
                  errors={methods.errors}
                  name="otherPackageType"
                  message={'Other package type is required.'}
                  as={<Alert color={'danger'} className={'mt-3'} />}
                />
              </p>
            </FormGroup>
          )}
        </Col>
        <Col xs={4}>
          <p>
            <strong>Organic</strong>
          </p>
          <Controller
            as={Switch}
            name="Organic"
            id="Organic"
            defaultValue={packaging.Organic}
            onChange={([checked, event, id]) => {
              setSwitchReviewer(item, checked, event, id)
              return checked
            }}
            control={methods.control}
            disabled={isDisabled}
          />
          <br />
          <hr />
          <p>
            <strong>
              I certify that this product contains NO added sugars, fats, oils,
              or artificial or natural flavors inluding essences. {asterisk}
            </strong>
          </p>
          <Controller
            as={Switch}
            name="NoAdditionalIngredients"
            id="NoAdditionalIngredients"
            defaultValue={packaging.NoAdditionalIngredients}
            onChange={([checked, event, id]) => {
              setSwitchReviewer(item, checked, event, id)
              return checked
            }}
            control={methods.control}
            rules={{
              validate: NoAdditionalIngredients =>
                NoAdditionalIngredients === true,
            }}
            disabled={isDisabled}
          />
          <br />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="NoAdditionalIngredients"
              message={
                '⚠ Product must contain NO sugars, fats, oils, or artificial or natural flavors including essences.'
              }
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </Col>
      </Row>
    </>
  )
}

DriedFruitsPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default DriedFruitsPackageReview
